import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loading-overlay';
import {I18nUtils} from "../../../i18n/I18nUtils";

export default class Card extends React.Component {

    render() {
        const {
            loading,
            colWidth,
            children,
            className,
        } = this.props;

        const widthClass = colWidth ? colWidth : 'col-lg-12 col-md-12 col-sm-12 col-xs-12';

        return (
            <div className={`${widthClass} ${className}`}>
                <div className="card">
                    <Loadable
                        active={loading}
                        spinner
                        text={I18nUtils.tr('TR_CARGANDO')}
                        background={'rgba(255,255,255,.9)'}
                        color={'rgb(0,0,0)'}
                        zIndex={10}
                    >
                        {children}
                    </Loadable>
                </div>
            </div>
        );
    }

}

Card.propTypes = {
    loading: PropTypes.bool,
    colWidth: PropTypes.string,
    className: PropTypes.string,
};

Card.defaultProps = {
    loading: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Card.jsx